import React from "react";
import { useLanguage } from "../contexts/LanguageContext";
import {
  Palette,
  Code2,
  ShoppingBag,
  TrendingUp,
  Sparkles,
  Wrench,
  ArrowUpRight,
} from "lucide-react";

const icons = {
  webdesign: Palette,
  development: Code2,
  ecommerce: ShoppingBag,
  seo: TrendingUp,
  branding: Sparkles,
  maintenance: Wrench,
};

const Services = () => {
  const { t } = useLanguage();
  const items = t.services.items;

  const Card = ({ keyName, span, featured }) => {
    const Icon = icons[keyName];
    const item = items[keyName];
    return (
      <div
        data-testid={`service-${keyName}`}
        className={`group relative rounded-3xl p-8 sm:p-10 transition-all duration-500 hover:-translate-y-1 ${
          featured
            ? "bg-brand text-white shadow-xl"
            : "bg-white border border-brand-line/70 hover:border-brand/40 hover:shadow-md"
        } ${span}`}
      >
        <div
          className={`w-12 h-12 rounded-2xl flex items-center justify-center mb-6 ${
            featured ? "bg-white/10" : "bg-brand-surface"
          }`}
        >
          <Icon
            size={22}
            strokeWidth={1.5}
            className={featured ? "text-white" : "text-brand"}
          />
        </div>
        <h3
          className={`font-display text-2xl sm:text-3xl font-medium tracking-tight mb-3 ${
            featured ? "text-white" : "text-brand-ink"
          }`}
        >
          {item.title}
        </h3>
        <p
          className={`text-base leading-relaxed max-w-md ${
            featured ? "text-white/80" : "text-brand-muted"
          }`}
        >
          {item.description}
        </p>

        <div
          className={`absolute top-6 right-6 w-10 h-10 rounded-full flex items-center justify-center transition-all duration-300 opacity-0 group-hover:opacity-100 group-hover:rotate-0 -rotate-45 ${
            featured ? "bg-white/10 text-white" : "bg-brand text-white"
          }`}
          aria-hidden
        >
          <ArrowUpRight size={16} strokeWidth={2} />
        </div>
      </div>
    );
  };

  return (
    <section
      id="services"
      data-testid="services-section"
      className="py-24 sm:py-32 px-5 sm:px-8 bg-brand-surface/40"
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6 mb-14 items-end">
          <div className="md:col-span-4">
            <div className="flex items-center gap-3 mb-4">
              <span className="w-10 h-px bg-brand" />
              <span className="text-[11px] tracking-[0.25em] font-bold text-brand">
                {t.services.eyebrow}
              </span>
            </div>
          </div>
          <h2
            className="md:col-span-8 font-display text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight text-brand-ink leading-tight"
            data-testid="services-title"
          >
            {t.services.title}
          </h2>
        </div>

        {/* Bento grid */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
          <Card keyName="webdesign" span="md:col-span-7" featured />
          <Card keyName="development" span="md:col-span-5" />
          <Card keyName="ecommerce" span="md:col-span-4" />
          <Card keyName="seo" span="md:col-span-4" />
          <Card keyName="branding" span="md:col-span-4" />
          <Card keyName="maintenance" span="md:col-span-12" />
        </div>
      </div>
    </section>
  );
};

export default Services;
